const merchize = [
  {
    "id": "67da8f77f68f63c8ae6d7d0a",
    "name": "All-over Print Youth Soccer Jersey",
    "sku": "YOSJVN",
    "thumbnail": "https://public-artworks.merchize.com/merchize-website/website-merchize-1307957.32219414-1745219273963.jpeg",
    "options": [
      {
        "option": "size",
        "values": [
          "YXS",
          "YS",
          "YM",
          "YL",
          "YXL"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "YOSJVN000000BA19",
        "size": "YXS",
        "color": ""
      },
      {
        "merchize_sku": "YOSJVN000000BA22",
        "size": "YL",
        "color": ""
      },
      {
        "merchize_sku": "YOSJVN000000BA21",
        "size": "YM",
        "color": ""
      },
      {
        "merchize_sku": "YOSJVN000000BA20",
        "size": "YS",
        "color": ""
      },
      {
        "merchize_sku": "YOSJVN000000BA23",
        "size": "YXL",
        "color": ""
      }
    ]
  },
  {
    "id": "67da8f4fc042ab2870861148",
    "name": "All-over Print Youth Soccer Jersey Set",
    "sku": "YSJSVN",
    "thumbnail": "https://public-artworks.merchize.com/merchize-website/website-merchize-6473300.376964584-1745221103188.jpeg",
    "options": [
      {
        "option": "size",
        "values": [
          "YXS",
          "YS",
          "YM",
          "YL",
          "YXL"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "YSJSVN000000BA19",
        "size": "YXS",
        "color": ""
      },
      {
        "merchize_sku": "YSJSVN000000BA21",
        "size": "YM",
        "color": ""
      },
      {
        "merchize_sku": "YSJSVN000000BA20",
        "size": "YS",
        "color": ""
      },
      {
        "merchize_sku": "YSJSVN000000BA23",
        "size": "YXL",
        "color": ""
      },
      {
        "merchize_sku": "YSJSVN000000BA22",
        "size": "YL",
        "color": ""
      }
    ]
  },
  {
    "id": "68527e5663f90a22675576e2",
    "name": "All-over Print Kid Soccer Jersey Set",
    "sku": "KSJSVN",
    "thumbnail": "https://public-artworks.merchize.com/merchize-website/website-merchize-2178325.183549226-1751533353110.jpeg",
    "options": [
      {
        "option": "size",
        "values": [
          "Toddler 2T",
          "Toddler 3T",
          "Toddler 4T",
          "Toddler 4",
          "Toddler 5T"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "KSJSVN000000EC21",
        "size": "Toddler 2T",
        "color": ""
      },
      {
        "merchize_sku": "KSJSVN000000EC22",
        "size": "Toddler 3T",
        "color": ""
      },
      {
        "merchize_sku": "KSJSVN000000EC23",
        "size": "Toddler 4T",
        "color": ""
      },
      {
        "merchize_sku": "KSJSVN000000EC24",
        "size": "Toddler 4",
        "color": ""
      },
      {
        "merchize_sku": "KSJSVN000000EC25",
        "size": "Toddler 5T",
        "color": ""
      }
    ]
  },
  {
    "id": "68525c3c371a9c59abf90567",
    "name": "All-over Print Kid Soccer Jersey",
    "sku": "KISJVN",
    "thumbnail": "https://public-artworks.merchize.com/merchize-website/website-merchize-9919509.197997501-1751533623778.jpeg",
    "options": [
      {
        "option": "size",
        "values": [
          "Toddler 2T",
          "Toddler 3T",
          "Toddler 4T",
          "Toddler 4",
          "Toddler 5T"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "KISJVN000000EC21",
        "size": "Toddler 2T",
        "color": ""
      },
      {
        "merchize_sku": "KISJVN000000EC22",
        "size": "Toddler 3T",
        "color": ""
      },
      {
        "merchize_sku": "KISJVN000000EC23",
        "size": "Toddler 4T",
        "color": ""
      },
      {
        "merchize_sku": "KISJVN000000EC24",
        "size": "Toddler 4",
        "color": ""
      },
      {
        "merchize_sku": "KISJVN000000EC25",
        "size": "Toddler 5T",
        "color": ""
      }
    ]
  },
  {
    "id": "68d4c67b8700b17c9d84921e",
    "name": "All-over Print Youth Soccer Jersey Shorts",
    "sku": "YSOSVN",
    "thumbnail": "https://public-artworks.merchize.com/merchize-website/website-merchize-5254717.265241364-1758781638922.webp",
    "options": [
      {
        "option": "size",
        "values": [
          "YXS",
          "YS",
          "YM",
          "YL",
          "YXL"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "YSOSVN000000BA19",
        "size": "YXS",
        "color": ""
      },
      {
        "merchize_sku": "YSOSVN000000BA20",
        "size": "YS",
        "color": ""
      },
      {
        "merchize_sku": "YSOSVN000000BA21",
        "size": "YM",
        "color": ""
      },
      {
        "merchize_sku": "YSOSVN000000BA22",
        "size": "YL",
        "color": ""
      },
      {
        "merchize_sku": "YSOSVN000000BA23",
        "size": "YXL",
        "color": ""
      }
    ]
  },
  {
    "id": "65b9c8e887fad1abe1753e7d",
    "name": "All-over Print Hoodie (Midweight)",
    "sku": "MWHDVN",
    "thumbnail": "https://merchize.com/wp-content/uploads/2022/11/AOP-Hoodie-Midweight.jpg",
    "options": [
      {
        "option": "size",
        "values": [
          "S",
          "M",
          "L",
          "XL",
          "2XL",
          "3XL",
          "4XL",
          "5XL"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "MWHDVN000000AA01",
        "size": "S",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA02",
        "size": "M",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA03",
        "size": "L",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA04",
        "size": "XL",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA05",
        "size": "2XL",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA06",
        "size": "3XL",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA07",
        "size": "4XL",
        "color": ""
      },
      {
        "merchize_sku": "MWHDVN000000AA08",
        "size": "5XL",
        "color": ""
      }
    ]
  },
  {
    "id": "65b9c8e887fad1f98e753e50",
    "name": "Youth T-shirt Gildan 5000B (Made in US)",
    "sku": "500BUS",
    "thumbnail": "https://merchize.com/wp-content/uploads/2020/11/youth-t-shirt.jpg",
    "options": [
      {
        "option": "color",
        "values": [
          "Black",
          "Irish Green",
          "Light Pink",
          "Navy",
          "Orange",
          "Purple",
          "Red",
          "Royal",
          "Sport Grey",
          "White",
          "Ash",
          "Cardinal Red",
          "Carolina Blue",
          "Charcoal",
          "Daisy",
          "Dark Heather",
          "Gold",
          "Heather Sapphire",
          "Heliconia",
          "Light Blue",
          "Lime",
          "Maroon",
          "Sapphire",
          "Forest Green",
          "Tennessee Orange",
          "Sand",
          "Azalea",
          "Cobalt",
          "Coral Silk",
          "Cornsilk",
          "Dark Chocolate",
          "Garnet",
          "Graphite Heather",
          "Heather Navy",
          "Heather Red",
          "Kiwi",
          "Military Green",
          "Natural",
          "Electric Green",
          "Neon Blue",
          "Indigo",
          "Mint",
          "Tropical Blue",
          "Violet",
          "Safety Green",
          "S Orange",
          "Safety Pink",
          "Sky",
          "Texas Orange",
          "Yellow Haze",
          "Neon Green"
        ]
      },
      {
        "option": "size",
        "values": [
          "YXS",
          "YS",
          "YM",
          "YL",
          "YXL"
        ]
      }
    ],
    "variants": [
      {
        "merchize_sku": "500BUS000BLKBA20",
        "size": "YS",
        "color": "Black"
      },
      {
        "merchize_sku": "500BUS000BLKBA21",
        "size": "YM",
        "color": "Black"
      },
      {
        "merchize_sku": "500BUS000BLKBA22",
        "size": "YL",
        "color": "Black"
      },
      {
        "merchize_sku": "500BUS000IRGBA20",
        "size": "YS",
        "color": "Irish Green"
      },
      {
        "merchize_sku": "500BUS000IRGBA21",
        "size": "YM",
        "color": "Irish Green"
      },
      {
        "merchize_sku": "500BUS000IRGBA22",
        "size": "YL",
        "color": "Irish Green"
      },
      {
        "merchize_sku": "500BUS000LTPBA20",
        "size": "YS",
        "color": "Light Pink"
      },
      {
        "merchize_sku": "500BUS000LTPBA21",
        "size": "YM",
        "color": "Light Pink"
      },
      {
        "merchize_sku": "500BUS000LTPBA22",
        "size": "YL",
        "color": "Light Pink"
      },
      {
        "merchize_sku": "500BUS000NAVBA20",
        "size": "YS",
        "color": "Navy"
      },
      {
        "merchize_sku": "500BUS000NAVBA21",
        "size": "YM",
        "color": "Navy"
      },
      {
        "merchize_sku": "500BUS000NAVBA22",
        "size": "YL",
        "color": "Navy"
      },
      {
        "merchize_sku": "500BUS000ORGBA20",
        "size": "YS",
        "color": "Orange"
      },
      {
        "merchize_sku": "500BUS000ORGBA21",
        "size": "YM",
        "color": "Orange"
      },
      {
        "merchize_sku": "500BUS000ORGBA22",
        "size": "YL",
        "color": "Orange"
      },
      {
        "merchize_sku": "500BUS000PPLBA20",
        "size": "YS",
        "color": "Purple"
      },
      {
        "merchize_sku": "500BUS000PPLBA21",
        "size": "YM",
        "color": "Purple"
      },
      {
        "merchize_sku": "500BUS000PPLBA22",
        "size": "YL",
        "color": "Purple"
      },
      {
        "merchize_sku": "500BUS000REDBA20",
        "size": "YS",
        "color": "Red"
      },
      {
        "merchize_sku": "500BUS000REDBA21",
        "size": "YM",
        "color": "Red"
      },
      {
        "merchize_sku": "500BUS000REDBA22",
        "size": "YL",
        "color": "Red"
      },
      {
        "merchize_sku": "500BUS000RYLBA20",
        "size": "YS",
        "color": "Royal"
      },
      {
        "merchize_sku": "500BUS000RYLBA21",
        "size": "YM",
        "color": "Royal"
      },
      {
        "merchize_sku": "500BUS000RYLBA22",
        "size": "YL",
        "color": "Royal"
      },
      {
        "merchize_sku": "500BUS000SGRBA20",
        "size": "YS",
        "color": "Sport Grey"
      },
      {
        "merchize_sku": "500BUS000SGRBA21",
        "size": "YM",
        "color": "Sport Grey"
      },
      {
        "merchize_sku": "500BUS000SGRBA22",
        "size": "YL",
        "color": "Sport Grey"
      },
      {
        "merchize_sku": "500BUS000WHIBA20",
        "size": "YS",
        "color": "White"
      },
      {
        "merchize_sku": "500BUS000WHIBA21",
        "size": "YM",
        "color": "White"
      },
      {
        "merchize_sku": "500BUS000WHIBA22",
        "size": "YL",
        "color": "White"
      },
      {
        "merchize_sku": "500BUS000ASHBA20",
        "size": "YS",
        "color": "Ash"
      },
      {
        "merchize_sku": "500BUS000ASHBA21",
        "size": "YM",
        "color": "Ash"
      },
      {
        "merchize_sku": "500BUS000ASHBA22",
        "size": "YL",
        "color": "Ash"
      },
      {
        "merchize_sku": "500BUS000CDRBA20",
        "size": "YS",
        "color": "Cardinal Red"
      },
      {
        "merchize_sku": "500BUS000CDRBA21",
        "size": "YM",
        "color": "Cardinal Red"
      },
      {
        "merchize_sku": "500BUS000CDRBA22",
        "size": "YL",
        "color": "Cardinal Red"
      },
      {
        "merchize_sku": "500BUS000CRBBA20",
        "size": "YS",
        "color": "Carolina Blue"
      },
      {
        "merchize_sku": "500BUS000CRBBA21",
        "size": "YM",
        "color": "Carolina Blue"
      },
      {
        "merchize_sku": "500BUS000CRBBA22",
        "size": "YL",
        "color": "Carolina Blue"
      },
      {
        "merchize_sku": "500BUS000CHCBA20",
        "size": "YS",
        "color": "Charcoal"
      },
      {
        "merchize_sku": "500BUS000CHCBA21",
        "size": "YM",
        "color": "Charcoal"
      },
      {
        "merchize_sku": "500BUS000CHCBA22",
        "size": "YL",
        "color": "Charcoal"
      },
      {
        "merchize_sku": "500BUS000DSYBA20",
        "size": "YS",
        "color": "Daisy"
      },
      {
        "merchize_sku": "500BUS000DSYBA21",
        "size": "YM",
        "color": "Daisy"
      },
      {
        "merchize_sku": "500BUS000DSYBA22",
        "size": "YL",
        "color": "Daisy"
      },
      {
        "merchize_sku": "500BUS000DKHBA20",
        "size": "YS",
        "color": "Dark Heather"
      },
      {
        "merchize_sku": "500BUS000DKHBA21",
        "size": "YM",
        "color": "Dark Heather"
      },
      {
        "merchize_sku": "500BUS000DKHBA22",
        "size": "YL",
        "color": "Dark Heather"
      },
      {
        "merchize_sku": "500BUS000GOLBA20",
        "size": "YS",
        "color": "Gold"
      },
      {
        "merchize_sku": "500BUS000GOLBA21",
        "size": "YM",
        "color": "Gold"
      },
      {
        "merchize_sku": "500BUS000GOLBA22",
        "size": "YL",
        "color": "Gold"
      },
      {
        "merchize_sku": "500BUS000HSPBA20",
        "size": "YS",
        "color": "Heather Sapphire"
      },
      {
        "merchize_sku": "500BUS000HSPBA21",
        "size": "YM",
        "color": "Heather Sapphire"
      },
      {
        "merchize_sku": "500BUS000HSPBA22",
        "size": "YL",
        "color": "Heather Sapphire"
      },
      {
        "merchize_sku": "500BUS000HLCBA20",
        "size": "YS",
        "color": "Heliconia"
      },
      {
        "merchize_sku": "500BUS000HLCBA21",
        "size": "YM",
        "color": "Heliconia"
      },
      {
        "merchize_sku": "500BUS000HLCBA22",
        "size": "YL",
        "color": "Heliconia"
      },
      {
        "merchize_sku": "500BUS000LTBBA20",
        "size": "YS",
        "color": "Light Blue"
      },
      {
        "merchize_sku": "500BUS000LTBBA21",
        "size": "YM",
        "color": "Light Blue"
      },
      {
        "merchize_sku": "500BUS000LTBBA22",
        "size": "YL",
        "color": "Light Blue"
      },
      {
        "merchize_sku": "500BUS000LIMBA20",
        "size": "YS",
        "color": "Lime"
      },
      {
        "merchize_sku": "500BUS000LIMBA21",
        "size": "YM",
        "color": "Lime"
      },
      {
        "merchize_sku": "500BUS000LIMBA22",
        "size": "YL",
        "color": "Lime"
      },
      {
        "merchize_sku": "500BUS000MRNBA20",
        "size": "YS",
        "color": "Maroon"
      },
      {
        "merchize_sku": "500BUS000MRNBA21",
        "size": "YM",
        "color": "Maroon"
      },
      {
        "merchize_sku": "500BUS000MRNBA22",
        "size": "YL",
        "color": "Maroon"
      },
      {
        "merchize_sku": "500BUS000SPHBA20",
        "size": "YS",
        "color": "Sapphire"
      },
      {
        "merchize_sku": "500BUS000SPHBA21",
        "size": "YM",
        "color": "Sapphire"
      },
      {
        "merchize_sku": "500BUS000SPHBA22",
        "size": "YL",
        "color": "Sapphire"
      },
      {
        "merchize_sku": "500BUS000FRGBA20",
        "size": "YS",
        "color": "Forest Green"
      },
      {
        "merchize_sku": "500BUS000FRGBA21",
        "size": "YM",
        "color": "Forest Green"
      },
      {
        "merchize_sku": "500BUS000FRGBA22",
        "size": "YL",
        "color": "Forest Green"
      },
      {
        "merchize_sku": "500BUS000TNOBA20",
        "size": "YS",
        "color": "Tennessee Orange"
      },
      {
        "merchize_sku": "500BUS000TNOBA21",
        "size": "YM",
        "color": "Tennessee Orange"
      },
      {
        "merchize_sku": "500BUS000TNOBA22",
        "size": "YL",
        "color": "Tennessee Orange"
      },
      {
        "merchize_sku": "500BUS000SANBA20",
        "size": "YS",
        "color": "Sand"
      },
      {
        "merchize_sku": "500BUS000SANBA21",
        "size": "YM",
        "color": "Sand"
      },
      {
        "merchize_sku": "500BUS000SANBA22",
        "size": "YL",
        "color": "Sand"
      },
      {
        "merchize_sku": "500BUS000AZLBA20",
        "size": "YS",
        "color": "Azalea"
      },
      {
        "merchize_sku": "500BUS000AZLBA21",
        "size": "YM",
        "color": "Azalea"
      },
      {
        "merchize_sku": "500BUS000AZLBA22",
        "size": "YL",
        "color": "Azalea"
      },
      {
        "merchize_sku": "500BUS000CBABA20",
        "size": "YS",
        "color": "Cobalt"
      },
      {
        "merchize_sku": "500BUS000CBABA21",
        "size": "YM",
        "color": "Cobalt"
      },
      {
        "merchize_sku": "500BUS000CBABA22",
        "size": "YL",
        "color": "Cobalt"
      },
      {
        "merchize_sku": "500BUS000CSIBA20",
        "size": "YS",
        "color": "Coral Silk"
      },
      {
        "merchize_sku": "500BUS000CSIBA21",
        "size": "YM",
        "color": "Coral Silk"
      },
      {
        "merchize_sku": "500BUS000CSIBA22",
        "size": "YL",
        "color": "Coral Silk"
      },
      {
        "merchize_sku": "500BUS000DCCBA20",
        "size": "YS",
        "color": "Dark Chocolate"
      },
      {
        "merchize_sku": "500BUS000DCCBA21",
        "size": "YM",
        "color": "Dark Chocolate"
      },
      {
        "merchize_sku": "500BUS000DCCBA22",
        "size": "YL",
        "color": "Dark Chocolate"
      },
      {
        "merchize_sku": "500BUS000GARBA20",
        "size": "YS",
        "color": "Garnet"
      },
      {
        "merchize_sku": "500BUS000GARBA21",
        "size": "YM",
        "color": "Garnet"
      },
      {
        "merchize_sku": "500BUS000GARBA22",
        "size": "YL",
        "color": "Garnet"
      },
      {
        "merchize_sku": "500BUS000GHEBA20",
        "size": "YS",
        "color": "Graphite Heather"
      },
      {
        "merchize_sku": "500BUS000GHEBA21",
        "size": "YM",
        "color": "Graphite Heather"
      },
      {
        "merchize_sku": "500BUS000GHEBA22",
        "size": "YL",
        "color": "Graphite Heather"
      },
      {
        "merchize_sku": "500BUS000HTNBA20",
        "size": "YS",
        "color": "Heather Navy"
      },
      {
        "merchize_sku": "500BUS000HTNBA21",
        "size": "YM",
        "color": "Heather Navy"
      },
      {
        "merchize_sku": "500BUS000HTNBA22",
        "size": "YL",
        "color": "Heather Navy"
      },
      {
        "merchize_sku": "500BUS000HREBA20",
        "size": "YS",
        "color": "Heather Red"
      },
      {
        "merchize_sku": "500BUS000HREBA21",
        "size": "YM",
        "color": "Heather Red"
      },
      {
        "merchize_sku": "500BUS000HREBA22",
        "size": "YL",
        "color": "Heather Red"
      },
      {
        "merchize_sku": "500BUS000KIWBA20",
        "size": "YS",
        "color": "Kiwi"
      },
      {
        "merchize_sku": "500BUS000KIWBA21",
        "size": "YM",
        "color": "Kiwi"
      },
      {
        "merchize_sku": "500BUS000KIWBA22",
        "size": "YL",
        "color": "Kiwi"
      },
      {
        "merchize_sku": "500BUS000MLGBA20",
        "size": "YS",
        "color": "Military Green"
      },
      {
        "merchize_sku": "500BUS000MLGBA21",
        "size": "YM",
        "color": "Military Green"
      },
      {
        "merchize_sku": "500BUS000MLGBA22",
        "size": "YL",
        "color": "Military Green"
      },
      {
        "merchize_sku": "500BUS000NATBA20",
        "size": "YS",
        "color": "Natural"
      },
      {
        "merchize_sku": "500BUS000NATBA21",
        "size": "YM",
        "color": "Natural"
      },
      {
        "merchize_sku": "500BUS000NATBA22",
        "size": "YL",
        "color": "Natural"
      },
      {
        "merchize_sku": "500BUS000ELGBA20",
        "size": "YS",
        "color": "Electric Green"
      },
      {
        "merchize_sku": "500BUS000ELGBA21",
        "size": "YM",
        "color": "Electric Green"
      },
      {
        "merchize_sku": "500BUS000ELGBA22",
        "size": "YL",
        "color": "Electric Green"
      },
      {
        "merchize_sku": "500BUS000NEBBA20",
        "size": "YS",
        "color": "Neon Blue"
      },
      {
        "merchize_sku": "500BUS000NEBBA21",
        "size": "YM",
        "color": "Neon Blue"
      },
      {
        "merchize_sku": "500BUS000NEBBA22",
        "size": "YL",
        "color": "Neon Blue"
      },
      {
        "merchize_sku": "500BUS000INDBA20",
        "size": "YS",
        "color": "Indigo"
      },
      {
        "merchize_sku": "500BUS000INDBA21",
        "size": "YM",
        "color": "Indigo"
      },
      {
        "merchize_sku": "500BUS000INDBA22",
        "size": "YL",
        "color": "Indigo"
      },
      {
        "merchize_sku": "500BUS000MINBA20",
        "size": "YS",
        "color": "Mint"
      },
      {
        "merchize_sku": "500BUS000MINBA21",
        "size": "YM",
        "color": "Mint"
      },
      {
        "merchize_sku": "500BUS000MINBA22",
        "size": "YL",
        "color": "Mint"
      },
      {
        "merchize_sku": "500BUS000TRBBA20",
        "size": "YS",
        "color": "Tropical Blue"
      },
      {
        "merchize_sku": "500BUS000TRBBA21",
        "size": "YM",
        "color": "Tropical Blue"
      },
      {
        "merchize_sku": "500BUS000TRBBA22",
        "size": "YL",
        "color": "Tropical Blue"
      },
      {
        "merchize_sku": "500BUS000VIOBA20",
        "size": "YS",
        "color": "Violet"
      },
      {
        "merchize_sku": "500BUS000VIOBA21",
        "size": "YM",
        "color": "Violet"
      },
      {
        "merchize_sku": "500BUS000VIOBA22",
        "size": "YL",
        "color": "Violet"
      },
      {
        "merchize_sku": "500BUS000SFGBA20",
        "size": "YS",
        "color": "Safety Green"
      },
      {
        "merchize_sku": "500BUS000SFGBA21",
        "size": "YM",
        "color": "Safety Green"
      },
      {
        "merchize_sku": "500BUS000SFGBA22",
        "size": "YL",
        "color": "Safety Green"
      },
      {
        "merchize_sku": "500BUS000SORBA20",
        "size": "YS",
        "color": "S Orange"
      },
      {
        "merchize_sku": "500BUS000SORBA21",
        "size": "YM",
        "color": "S Orange"
      },
      {
        "merchize_sku": "500BUS000SORBA22",
        "size": "YL",
        "color": "S Orange"
      },
      {
        "merchize_sku": "500BUS000STPBA20",
        "size": "YS",
        "color": "Safety Pink"
      },
      {
        "merchize_sku": "500BUS000STPBA21",
        "size": "YM",
        "color": "Safety Pink"
      },
      {
        "merchize_sku": "500BUS000STPBA22",
        "size": "YL",
        "color": "Safety Pink"
      },
      {
        "merchize_sku": "500BUS000SKYBA20",
        "size": "YS",
        "color": "Sky"
      },
      {
        "merchize_sku": "500BUS000SKYBA21",
        "size": "YM",
        "color": "Sky"
      },
      {
        "merchize_sku": "500BUS000SKYBA22",
        "size": "YL",
        "color": "Sky"
      },
      {
        "merchize_sku": "500BUS000TORBA20",
        "size": "YS",
        "color": "Texas Orange"
      },
      {
        "merchize_sku": "500BUS000TORBA21",
        "size": "YM",
        "color": "Texas Orange"
      },
      {
        "merchize_sku": "500BUS000TORBA22",
        "size": "YL",
        "color": "Texas Orange"
      },
      {
        "merchize_sku": "500BUS000YLHBA20",
        "size": "YS",
        "color": "Yellow Haze"
      },
      {
        "merchize_sku": "500BUS000YLHBA21",
        "size": "YM",
        "color": "Yellow Haze"
      },
      {
        "merchize_sku": "500BUS000YLHBA22",
        "size": "YL",
        "color": "Yellow Haze"
      },
      {
        "merchize_sku": "500BUS000NOGBA20",
        "size": "YS",
        "color": "Neon Green"
      },
      {
        "merchize_sku": "500BUS000NOGBA21",
        "size": "YM",
        "color": "Neon Green"
      },
      {
        "merchize_sku": "500BUS000NOGBA22",
        "size": "YL",
        "color": "Neon Green"
      },
      {
        "merchize_sku": "500BUS000BLKBA19",
        "size": "YXS",
        "color": "Black"
      },
      {
        "merchize_sku": "500BUS000ORGBA19",
        "size": "YXS",
        "color": "Orange"
      },
      {
        "merchize_sku": "500BUS000LTPBA19",
        "size": "YXS",
        "color": "Light Pink"
      },
      {
        "merchize_sku": "500BUS000NAVBA19",
        "size": "YXS",
        "color": "Navy"
      },
      {
        "merchize_sku": "500BUS000IRGBA19",
        "size": "YXS",
        "color": "Irish Green"
      },
      {
        "merchize_sku": "500BUS000PPLBA19",
        "size": "YXS",
        "color": "Purple"
      },
      {
        "merchize_sku": "500BUS000REDBA19",
        "size": "YXS",
        "color": "Red"
      },
      {
        "merchize_sku": "500BUS000RYLBA19",
        "size": "YXS",
        "color": "Royal"
      },
      {
        "merchize_sku": "500BUS000ASHBA19",
        "size": "YXS",
        "color": "Ash"
      },
      {
        "merchize_sku": "500BUS000CDRBA19",
        "size": "YXS",
        "color": "Cardinal Red"
      },
      {
        "merchize_sku": "500BUS000SGRBA19",
        "size": "YXS",
        "color": "Sport Grey"
      },
      {
        "merchize_sku": "500BUS000WHIBA19",
        "size": "YXS",
        "color": "White"
      },
      {
        "merchize_sku": "500BUS000CHCBA19",
        "size": "YXS",
        "color": "Charcoal"
      },
      {
        "merchize_sku": "500BUS000DSYBA19",
        "size": "YXS",
        "color": "Daisy"
      },
      {
        "merchize_sku": "500BUS000DKHBA19",
        "size": "YXS",
        "color": "Dark Heather"
      },
      {
        "merchize_sku": "500BUS000CRBBA19",
        "size": "YXS",
        "color": "Carolina Blue"
      },
      {
        "merchize_sku": "500BUS000GOLBA19",
        "size": "YXS",
        "color": "Gold"
      },
      {
        "merchize_sku": "500BUS000HLCBA19",
        "size": "YXS",
        "color": "Heliconia"
      },
      {
        "merchize_sku": "500BUS000HSPBA19",
        "size": "YXS",
        "color": "Heather Sapphire"
      },
      {
        "merchize_sku": "500BUS000LTBBA19",
        "size": "YXS",
        "color": "Light Blue"
      },
      {
        "merchize_sku": "500BUS000SPHBA19",
        "size": "YXS",
        "color": "Sapphire"
      },
      {
        "merchize_sku": "500BUS000MRNBA19",
        "size": "YXS",
        "color": "Maroon"
      },
      {
        "merchize_sku": "500BUS000LIMBA19",
        "size": "YXS",
        "color": "Lime"
      },
      {
        "merchize_sku": "500BUS000FRGBA19",
        "size": "YXS",
        "color": "Forest Green"
      },
      {
        "merchize_sku": "500BUS000TNOBA19",
        "size": "YXS",
        "color": "Tennessee Orange"
      },
      {
        "merchize_sku": "500BUS000SANBA19",
        "size": "YXS",
        "color": "Sand"
      },
      {
        "merchize_sku": "500BUS000CBABA19",
        "size": "YXS",
        "color": "Cobalt"
      },
      {
        "merchize_sku": "500BUS000AZLBA19",
        "size": "YXS",
        "color": "Azalea"
      },
      {
        "merchize_sku": "500BUS000DCCBA19",
        "size": "YXS",
        "color": "Dark Chocolate"
      },
      {
        "merchize_sku": "500BUS000GARBA19",
        "size": "YXS",
        "color": "Garnet"
      },
      {
        "merchize_sku": "500BUS000CSIBA19",
        "size": "YXS",
        "color": "Coral Silk"
      },
      {
        "merchize_sku": "500BUS000HTNBA19",
        "size": "YXS",
        "color": "Heather Navy"
      },
      {
        "merchize_sku": "500BUS000GHEBA19",
        "size": "YXS",
        "color": "Graphite Heather"
      },
      {
        "merchize_sku": "500BUS000HREBA19",
        "size": "YXS",
        "color": "Heather Red"
      },
      {
        "merchize_sku": "500BUS000MLGBA19",
        "size": "YXS",
        "color": "Military Green"
      },
      {
        "merchize_sku": "500BUS000KIWBA19",
        "size": "YXS",
        "color": "Kiwi"
      },
      {
        "merchize_sku": "500BUS000NATBA19",
        "size": "YXS",
        "color": "Natural"
      },
      {
        "merchize_sku": "500BUS000ELGBA19",
        "size": "YXS",
        "color": "Electric Green"
      },
      {
        "merchize_sku": "500BUS000NEBBA19",
        "size": "YXS",
        "color": "Neon Blue"
      },
      {
        "merchize_sku": "500BUS000INDBA19",
        "size": "YXS",
        "color": "Indigo"
      },
      {
        "merchize_sku": "500BUS000TRBBA19",
        "size": "YXS",
        "color": "Tropical Blue"
      },
      {
        "merchize_sku": "500BUS000MINBA19",
        "size": "YXS",
        "color": "Mint"
      },
      {
        "merchize_sku": "500BUS000VIOBA19",
        "size": "YXS",
        "color": "Violet"
      },
      {
        "merchize_sku": "500BUS000SORBA19",
        "size": "YXS",
        "color": "S Orange"
      },
      {
        "merchize_sku": "500BUS000SFGBA19",
        "size": "YXS",
        "color": "Safety Green"
      },
      {
        "merchize_sku": "500BUS000SKYBA19",
        "size": "YXS",
        "color": "Sky"
      },
      {
        "merchize_sku": "500BUS000STPBA19",
        "size": "YXS",
        "color": "Safety Pink"
      },
      {
        "merchize_sku": "500BUS000YLHBA19",
        "size": "YXS",
        "color": "Yellow Haze"
      },
      {
        "merchize_sku": "500BUS000TORBA19",
        "size": "YXS",
        "color": "Texas Orange"
      },
      {
        "merchize_sku": "500BUS000NOGBA19",
        "size": "YXS",
        "color": "Neon Green"
      },
      {
        "merchize_sku": "500BUS000BLKBA23",
        "size": "YXL",
        "color": "Black"
      },
      {
        "merchize_sku": "500BUS000IRGBA23",
        "size": "YXL",
        "color": "Irish Green"
      },
      {
        "merchize_sku": "500BUS000LTPBA23",
        "size": "YXL",
        "color": "Light Pink"
      },
      {
        "merchize_sku": "500BUS000NAVBA23",
        "size": "YXL",
        "color": "Navy"
      },
      {
        "merchize_sku": "500BUS000REDBA23",
        "size": "YXL",
        "color": "Red"
      },
      {
        "merchize_sku": "500BUS000PPLBA23",
        "size": "YXL",
        "color": "Purple"
      },
      {
        "merchize_sku": "500BUS000ORGBA23",
        "size": "YXL",
        "color": "Orange"
      },
      {
        "merchize_sku": "500BUS000RYLBA23",
        "size": "YXL",
        "color": "Royal"
      },
      {
        "merchize_sku": "500BUS000SGRBA23",
        "size": "YXL",
        "color": "Sport Grey"
      },
      {
        "merchize_sku": "500BUS000CDRBA23",
        "size": "YXL",
        "color": "Cardinal Red"
      },
      {
        "merchize_sku": "500BUS000WHIBA23",
        "size": "YXL",
        "color": "White"
      },
      {
        "merchize_sku": "500BUS000ASHBA23",
        "size": "YXL",
        "color": "Ash"
      },
      {
        "merchize_sku": "500BUS000CRBBA23",
        "size": "YXL",
        "color": "Carolina Blue"
      },
      {
        "merchize_sku": "500BUS000CHCBA23",
        "size": "YXL",
        "color": "Charcoal"
      },
      {
        "merchize_sku": "500BUS000DKHBA23",
        "size": "YXL",
        "color": "Dark Heather"
      },
      {
        "merchize_sku": "500BUS000GOLBA23",
        "size": "YXL",
        "color": "Gold"
      },
      {
        "merchize_sku": "500BUS000DSYBA23",
        "size": "YXL",
        "color": "Daisy"
      },
      {
        "merchize_sku": "500BUS000HLCBA23",
        "size": "YXL",
        "color": "Heliconia"
      },
      {
        "merchize_sku": "500BUS000HSPBA23",
        "size": "YXL",
        "color": "Heather Sapphire"
      },
      {
        "merchize_sku": "500BUS000LTBBA23",
        "size": "YXL",
        "color": "Light Blue"
      },
      {
        "merchize_sku": "500BUS000MRNBA23",
        "size": "YXL",
        "color": "Maroon"
      },
      {
        "merchize_sku": "500BUS000LIMBA23",
        "size": "YXL",
        "color": "Lime"
      },
      {
        "merchize_sku": "500BUS000FRGBA23",
        "size": "YXL",
        "color": "Forest Green"
      },
      {
        "merchize_sku": "500BUS000SPHBA23",
        "size": "YXL",
        "color": "Sapphire"
      },
      {
        "merchize_sku": "500BUS000SANBA23",
        "size": "YXL",
        "color": "Sand"
      },
      {
        "merchize_sku": "500BUS000TNOBA23",
        "size": "YXL",
        "color": "Tennessee Orange"
      },
      {
        "merchize_sku": "500BUS000AZLBA23",
        "size": "YXL",
        "color": "Azalea"
      },
      {
        "merchize_sku": "500BUS000CBABA23",
        "size": "YXL",
        "color": "Cobalt"
      },
      {
        "merchize_sku": "500BUS000CSIBA23",
        "size": "YXL",
        "color": "Coral Silk"
      },
      {
        "merchize_sku": "500BUS000DCCBA23",
        "size": "YXL",
        "color": "Dark Chocolate"
      },
      {
        "merchize_sku": "500BUS000GARBA23",
        "size": "YXL",
        "color": "Garnet"
      },
      {
        "merchize_sku": "500BUS000HREBA23",
        "size": "YXL",
        "color": "Heather Red"
      },
      {
        "merchize_sku": "500BUS000HTNBA23",
        "size": "YXL",
        "color": "Heather Navy"
      },
      {
        "merchize_sku": "500BUS000GHEBA23",
        "size": "YXL",
        "color": "Graphite Heather"
      },
      {
        "merchize_sku": "500BUS000MLGBA23",
        "size": "YXL",
        "color": "Military Green"
      },
      {
        "merchize_sku": "500BUS000NATBA23",
        "size": "YXL",
        "color": "Natural"
      },
      {
        "merchize_sku": "500BUS000KIWBA23",
        "size": "YXL",
        "color": "Kiwi"
      },
      {
        "merchize_sku": "500BUS000ELGBA23",
        "size": "YXL",
        "color": "Electric Green"
      },
      {
        "merchize_sku": "500BUS000NEBBA23",
        "size": "YXL",
        "color": "Neon Blue"
      },
      {
        "merchize_sku": "500BUS000INDBA23",
        "size": "YXL",
        "color": "Indigo"
      },
      {
        "merchize_sku": "500BUS000MINBA23",
        "size": "YXL",
        "color": "Mint"
      },
      {
        "merchize_sku": "500BUS000TRBBA23",
        "size": "YXL",
        "color": "Tropical Blue"
      },
      {
        "merchize_sku": "500BUS000SFGBA23",
        "size": "YXL",
        "color": "Safety Green"
      },
      {
        "merchize_sku": "500BUS000VIOBA23",
        "size": "YXL",
        "color": "Violet"
      },
      {
        "merchize_sku": "500BUS000STPBA23",
        "size": "YXL",
        "color": "Safety Pink"
      },
      {
        "merchize_sku": "500BUS000SORBA23",
        "size": "YXL",
        "color": "S Orange"
      },
      {
        "merchize_sku": "500BUS000SKYBA23",
        "size": "YXL",
        "color": "Sky"
      },
      {
        "merchize_sku": "500BUS000NOGBA23",
        "size": "YXL",
        "color": "Neon Green"
      },
      {
        "merchize_sku": "500BUS000YLHBA23",
        "size": "YXL",
        "color": "Yellow Haze"
      },
      {
        "merchize_sku": "500BUS000TORBA23",
        "size": "YXL",
        "color": "Texas Orange"
      }
    ]
  }
]
export default merchize
